var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.transferPageShow
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "transfer-right-body",
          attrs: {
            id: "cloudTransfer",
            "element-loading-background": "rgba(0, 0, 0, 0.05)"
          }
        },
        [
          _c("div", { staticClass: "task-top" }, [
            _c("div", { staticClass: "task-top-position" }, [
              _c("div", { staticClass: "transfer-name" }, [
                _vm._v(_vm._s(_vm.$t("language.leftBanner.cloudTransfer")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "transfer-description" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.cloudTransfer.transferDescription"))
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-middle" }, [
            _c("div", { staticClass: "task-box-position" }, [
              _c(
                "div",
                {
                  staticClass: "task-box",
                  class: _vm.boxFrom,
                  on: {
                    click: function($event) {
                      return _vm.transferSourceDialogShow()
                    }
                  }
                },
                [
                  _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                    (_vm.hasSelectItems == false &&
                      _vm.hasSelectItemsMore == false) ||
                    _vm.mulitDrives.length == 0
                      ? _c("div", { staticClass: "task-operating" }, [
                          _c(
                            "div",
                            {
                              class:
                                _vm.$i18n.locale == "france"
                                  ? "task-operating-none"
                                  : "task-operating-name"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("language.cloudTransfer.from"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "task-operating-des" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.cloudTransfer.transferOperateFrom"
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasSelectItems || _vm.mulitDrives.length == 1
                      ? _c("div", { staticClass: "task-main" }, [
                          _c("div", {
                            staticClass: "task-type task-icon",
                            class: _vm.mulitDrives[0].driveType + "_big"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "task-catalog",
                              attrs: { title: _vm.mulitDrives[0].formUrl }
                            },
                            [_vm._v(_vm._s(_vm.mulitDrives[0].formUrl))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasSelectItemsMore && _vm.mulitDrives.length > 1
                      ? _c(
                          "div",
                          { staticClass: "task-source-more" },
                          _vm._l(_vm.mulitDrives, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "source-item",
                                on: {
                                  mouseenter: function($event) {
                                    _vm.hoverCurrent = index
                                  },
                                  mouseleave: function($event) {
                                    _vm.hoverCurrent = -1
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "item-formicon",
                                  class: [
                                    item.appName
                                      ? "icon " + item.appName + "-small"
                                      : "small-file",
                                    item.dir ? "folder-small" : "",
                                    !item.dir && !item.appName
                                      ? _vm.matchfileType(item.name) + "-small"
                                      : ""
                                  ]
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-url",
                                    attrs: { title: item.formUrl }
                                  },
                                  [_vm._v(_vm._s(item.formUrl))]
                                ),
                                _vm._v(" "),
                                _vm.hoverCurrent == index
                                  ? _c("div", {
                                      staticClass:
                                        "icon-util round-cancel round-cancel-position",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.removeItem(index, item.id)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "task-box",
                  class: _vm.boxTo,
                  on: {
                    click: function($event) {
                      return _vm.transferAimsDialogShow()
                    }
                  }
                },
                [
                  _vm.hasSelect
                    ? _c("div", { staticClass: "task-operating" }, [
                        _c("div", { staticClass: "task-operating-name" }, [
                          _vm._v(_vm._s(_vm.$t("language.cloudTransfer.to")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "task-operating-des" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.cloudTransfer.transferOperateTo")
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hasSelect
                    ? _c("div", { staticClass: "task-main" }, [
                        _c("div", {
                          staticClass: "task-type task-icon",
                          class: _vm.singleDrives.driveType + "_big"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "task-catalog",
                            attrs: { title: _vm.singleDrives.cloudCatalog }
                          },
                          [_vm._v(_vm._s(_vm.singleDrives.cloudCatalog))]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "definite-operating" }, [
              _c(
                "div",
                { staticStyle: { position: "relative" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "operating-options",
                      on: {
                        click: function($event) {
                          return _vm.openOptionsDialog()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util setting",
                        staticStyle: { float: "left" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "operating-position" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.options")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "operating-schedule",
                      on: {
                        click: function($event) {
                          return _vm.openSchduleDialog()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util",
                        class: _vm.checkedSchedule ? "check" : "nocheck",
                        staticStyle: { float: "left" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.checkedOpen()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "operating-position" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.schedule")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("edit-input", {
                    ref: "editInput",
                    attrs: {
                      inputValue: _vm.inputValue,
                      submitTaskName: _vm.submiTransfertName
                    }
                  }),
                  _vm._v(" "),
                  !_vm.checkedSchedule
                    ? _c(
                        "button",
                        {
                          staticClass: "transfer-button",
                          on: {
                            click: function($event) {
                              return _vm.transferNow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon transfer-icon-position cloudTransfer"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudTransfer.transferNow")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkedSchedule
                    ? _c(
                        "div",
                        {
                          staticClass: "schedule-button",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.transferAddTask()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "text-button-position" }, [
                            _c("div", {
                              staticClass:
                                "icon transfer-task-position cloudTransfer"
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { float: "left", color: "#fff" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.cloudTransfer.addTaskOnly")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "more-button-position",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.addTaskIconShow()
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util  transfer-up-position",
                                class: _vm.addTaskShow
                                  ? "transfer-up"
                                  : "transfer-down"
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.addTaskShow
                    ? _c(
                        "div",
                        {
                          staticClass: "addTask",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.addTransferNow()
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "task-type-icon-min transfer-blue-min transfer-blue-position"
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudTransfer.addTaskNow")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "flow" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.flowShow,
                            expression: "flowShow"
                          }
                        ],
                        staticClass: "flow-icon",
                        attrs: { id: "transferFlow" }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "icon transfer-task-position cloudTransfer flow-icon-position"
                        })
                      ]
                    )
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-buttom" }),
          _vm._v(" "),
          _c("transferAimsDialog", { ref: "transferAimsDialog" }),
          _vm._v(" "),
          _c("transferSourceDialog", { ref: "transferSourceDialog" }),
          _vm._v(" "),
          _c("transferOptionsDialog", { ref: "transferOptionsDialog" }),
          _vm._v(" "),
          _c("transferScheduleDialog", {
            ref: "transferScheduleDialog",
            attrs: { schedules: _vm.pSchedules }
          }),
          _vm._v(" "),
          _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
          _vm._v(" "),
          _c("noticeDialog", { ref: "noticeDialog" }),
          _vm._v(" "),
          _c("remindBindEmailDialog", { ref: "remindBindEmailDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "task-box-middle" }, [
      _c("div", { staticClass: "arrow-position" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-470efbff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-470efbff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/cloud_transfer.vue
// module id = null
// module chunks = 